export const SET_ACTIVE_JOURNEY = 'SET_ACTIVE_JOURNEY';
